import { ICellRendererParams } from "ag-grid-enterprise";
import React from "react";

import { IgCheckbox, IgTooltip } from "@intelligems/ig-theme";
import { useConfiguration } from "@src/api/configurations/use-configuration";
import { GenericFlexStartContainer } from "@src/components/MainApp/SharedProductPicker/list/containers";
import { useDispatch, useSelector } from "@src/store";
import { toggleProduct } from "@src/store/slices/productPicker";
import { isProductPickerProductSelected } from "@src/store/slices/productPicker/selectors/isProductPickerProductSelected";
import {
  ProductPickerProduct,
  ProductPickerSelectedProduct,
} from "@src/store/slices/productPicker/types";

export const ProductListCheckBox = ({
  data,
}: ICellRendererParams<ProductPickerSelectedProduct>) => {
  const checked = useSelector(isProductPickerProductSelected(data?.id));
  const dispatch = useDispatch();
  const isBundle = (data as ProductPickerProduct)?.isBundle || false;
  const enableBundleProducts =
    useConfiguration<boolean>("enable_bundle_products")?.value ?? false;
  const isBundleDisabled = isBundle && !enableBundleProducts;

  const onChange = () => {
    if (data) {
      if (checked || !isBundleDisabled) {
        dispatch(toggleProduct(data));
      }
    }
  };
  return (
    <GenericFlexStartContainer>
      <IgTooltip
        title={
          isBundleDisabled
            ? "Bundle products are not supported in price tests"
            : ""
        }
      >
        <IgCheckbox
          disabled={isBundleDisabled}
          checked={checked}
          onChange={onChange}
        />
      </IgTooltip>
    </GenericFlexStartContainer>
  );
};
